/* eslint-disable @typescript-eslint/ban-types */
import { EntityState } from '@ngrx/entity';
import { MemoizedSelector } from '@ngrx/store';
import { ElioError } from './error.model';

export type LoadingState = 'INIT' | 'LOADING' | 'LOADED';

export interface ErrorState {
  error: ElioError;
}

export type CallState = LoadingState | ErrorState;

export const getError = (callState: CallState): ElioError | undefined => {
  if ((callState as ErrorState).error !== undefined) {
    return (callState as ErrorState).error;
  }
  return undefined;
};

export const isLoadedOrInError = (callState: CallState): boolean => callState === 'LOADED' || isErrorState(callState);

export const isErrorState = (callState: CallState): callState is ErrorState =>
  Object.prototype.hasOwnProperty.call(callState, 'error');

export type EntityCallState<T> = EntityState<T> & SimpleEntityCallState;

export interface SimpleEntityCallState {
  callState: CallState;
}

export interface CallStateSelector {
  callState: CallState;
  errorMessage: string;
  loading: boolean;
  loaded: boolean;
}

export type CallStateSelectors<FeatureName extends string, C = CallStateSelector> = {
  [K in keyof C & string as `${CapitalizeSelector<C[K], FeatureName, K>}`]: MemoizedSelector<object, C[K]>;
};

type CapitalizeSelector<Type, FeatureName extends string, K extends string> = Type extends boolean
  ? `is${Capitalize<FeatureName>}${Capitalize<K>}`
  : `get${Capitalize<FeatureName>}${Capitalize<K>}`;
